var map = {
	"./Customer Agreement.png": 992,
	"./Dashboard-bg.png": 993,
	"./Export Control.png": 994,
	"./Foundry NDA.png": 995,
	"./Purchase Order.png": 996,
	"./Quote.png": 997,
	"./Welcome.png": 998,
	"./add_doc.png": 999,
	"./descendant.png": 1000,
	"./login.png": 481,
	"./logo-2.png": 480,
	"./logo.png": 1001,
	"./logo_2.png": 1002
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 991;